import React from 'react';
import { X, Share2, Trophy } from 'lucide-react';
import { Challenge } from '../../types/challenges';

interface CongratulationsModalProps {
  challenge: Challenge;
  isOpen: boolean;
  onClose: () => void;
}

export function CongratulationsModal({ challenge, isOpen, onClose }: CongratulationsModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[200] p-4">
      <div className="bg-gradient-to-br from-[#1C1C1C] to-[#888888] shadow-lg w-full max-w-md text-white text-center">
        <div className="p-6 border-b border-white/10">
          <div className="flex justify-end">
            <button 
              onClick={onClose}
              className="text-white/70 hover:text-white transition-colors p-1 hover:bg-white/10 rounded-full"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="flex flex-col items-center -mt-6">
            <Trophy className="w-16 h-16 text-yellow-400 mb-4" />
            <h2 className="text-2xl text-white font-brand font-light italic mb-2">
              Congratulations!
            </h2>
            <p className="text-white/80">
              You've successfully completed the challenge:
            </p>
            <p className="text-xl text-amber-400 font-brand font-light italic mt-2">
              {challenge.title}
            </p>
          </div>
        </div>

        <div className="p-6">
          <p className="text-white/80 mb-6">
            Would you like to share your achievement with the community?
          </p>

          <button
            onClick={() => {
              // Share functionality will be implemented later
              onClose();
            }}
            className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-gradient-to-r from-blue-500/90 to-blue-600/90 hover:from-blue-500 hover:to-blue-600 text-white rounded-xl transition-all duration-300"
          >
            <Share2 className="w-4 h-4" />
            Share Results
          </button>
        </div>
      </div>
    </div>
  );
}